var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "svg-public/img/icons/spinner.svg__a",
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/spinner.svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#020202",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-146 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#040404",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-144 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#060606",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-142 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#080808",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-140 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#0A0A0A",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-138 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#0C0C0C",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-136 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#0E0E0E",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-134 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#101010",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-132 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#131313",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-130 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#151515",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-128 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#171717",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-126 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#191919",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-124 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#1B1B1B",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-122 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#1D1D1D",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-120 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#1F1F1F",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-118 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#212121",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-116 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#242424",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-114 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#262626",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-112 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#282828",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-110 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#2A2A2A",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-108 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#2C2C2C",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-106 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#2E2E2E",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-104 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#303030",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-102 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#323232",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-100 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#353535",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-98 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#373737",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-96 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#393939",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-94 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#3B3B3B",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-92 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#3D3D3D",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-90 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#3F3F3F",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-88 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#414141",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-86 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#434343",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-84 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#464646",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-82 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#484848",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-80 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#4A4A4A",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-78 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#4C4C4C",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-76 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#4E4E4E",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-74 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#505050",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-72 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#525252",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-70 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#545454",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-68 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#575757",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-66 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#595959",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-64 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#5B5B5B",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-62 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#5D5D5D",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-60 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#5F5F5F",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-58 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#616161",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-56 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#636363",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-54 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#656565",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-52 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#686868",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-50 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#6A6A6A",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-48 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#6C6C6C",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-46 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#6E6E6E",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-44 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#707070",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-42 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#727272",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-40 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#747474",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-38 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#767676",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-36 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#797979",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-34 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#7B7B7B",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-32 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#7D7D7D",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-30 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#7F7F7F",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-28 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#818181",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-26 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#838383",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-24 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#858585",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-22 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#878787",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-20 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#8A8A8A",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-18 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#8C8C8C",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-16 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#8E8E8E",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-14 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#909090",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-12 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#929292",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-10 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#949494",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-8 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#969696",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-6 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#989898",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-4 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#9B9B9B",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(-2 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#9D9D9D",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#9F9F9F",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(2 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#A1A1A1",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(4 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#A3A3A3",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(6 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#A5A5A5",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(8 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#A7A7A7",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(10 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#A9A9A9",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(12 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#ACACAC",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(14 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#AEAEAE",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(16 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#B0B0B0",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(18 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#B2B2B2",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(20 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#B4B4B4",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(22 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#B6B6B6",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(24 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#B8B8B8",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(26 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#BABABA",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(28 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#BDBDBD",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(30 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#BFBFBF",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(32 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#C1C1C1",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(34 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#C3C3C3",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(36 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#C5C5C5",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(38 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#C7C7C7",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(40 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#C9C9C9",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(42 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#CBCBCB",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(44 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#CECECE",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(46 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#D0D0D0",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(48 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#D2D2D2",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(50 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#D4D4D4",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(52 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#D6D6D6",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(54 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#D8D8D8",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(56 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#DADADA",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(58 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#DCDCDC",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(60 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#DFDFDF",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(62 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#E1E1E1",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(64 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#E3E3E3",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(66 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#E5E5E5",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(68 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#E7E7E7",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(70 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#E9E9E9",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(72 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#EBEBEB",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(74 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#EDEDED",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(76 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#F0F0F0",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(78 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#F2F2F2",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(80 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#F4F4F4",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(82 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#F6F6F6",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(84 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#F8F8F8",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(86 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FAFAFA",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(88 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FCFCFC",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(90 32 32)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FEFEFE",
  xlinkHref: "#svg-public/img/icons/spinner.svg__a",
  transform: "rotate(92 32 32)"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M54.6 47.6c-1.98-1.98-5.09-1.98-7.07 0-8.56 8.56-22.6 8.56-31.1 0-8.56-8.56-8.56-22.6 0-31.1 4.54-5.58-3.25-10.7-7.07-7.07-12.4 12.4-12.4 32.8 0 45.3 12.4 12.4 32.8 12.4 45.3 0 1.98-1.98 1.98-5.09 0-7.07zM32 54c-12.1 0-22-9.9-22-22s9.9-22 22-22c2.8 0 5-2.2 5-5s-2.2-5-5-5C14.4 0 0 14.4 0 32s14.4 32 32 32c7.16-.736 5.26-9.84 0-10z",
  mask: "url(#svg-public/img/icons/spinner.svg__b)"
})));
export { SvgSpinner as ReactComponent };